import { render, staticRenderFns } from "./licensePhysics.vue?vue&type=template&id=69ccaef2&scoped=true&"
import script from "./licensePhysics.vue?vue&type=script&lang=js&"
export * from "./licensePhysics.vue?vue&type=script&lang=js&"
import style0 from "./licensePhysics.vue?vue&type=style&index=0&id=69ccaef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ccaef2",
  null
  
)

export default component.exports